<input type="text"
       [placeholder]="placeHolder"
       #input
       [resultTemplate]="rt"
       [inputFormatter]="formatter"
       [ngbTypeahead]="searchFirmwareVersionBinding"
       (selectItem)="onSelectItem($event)"
       [editable]="false"
       [value]="displayFirmwareVersion">

<ng-template #rt
             let-r="result"
             let-t="term">
    <ngb-highlight [result]="formatModule(r)"
                   [term]="t"></ngb-highlight>
</ng-template>